
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { InvestmentOpportunity } from "@/types/investment";

interface BalloonPaymentSectionProps {
  formData: InvestmentOpportunity;
  onInputChange: (field: keyof InvestmentOpportunity, value: any) => void;
  onNumericChange: (field: keyof InvestmentOpportunity, value: string) => void;
}

const BalloonPaymentSection = ({ formData, onInputChange, onNumericChange }: BalloonPaymentSectionProps) => {
  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold mb-4">Balloon Payment Details</h3>
      
      <div className="flex items-center space-x-2 mb-4">
        <Checkbox
          id="has_balloon_payment"
          checked={formData.has_balloon_payment}
          onCheckedChange={(checked) => onInputChange('has_balloon_payment', checked)}
        />
        <Label htmlFor="has_balloon_payment">This contract has a balloon payment</Label>
      </div>

      {formData.has_balloon_payment && (
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="balloon_payment_amount">Balloon Payment Amount</Label>
            <Input
              id="balloon_payment_amount"
              type="number"
              step="0.01"
              value={formData.balloon_payment_amount === 0 ? '' : formData.balloon_payment_amount || ''}
              onChange={(e) => onNumericChange('balloon_payment_amount', e.target.value)}
              placeholder="Enter amount"
            />
          </div>
          <div>
            <Label htmlFor="balloon_payment_due_date">Balloon Payment Due Date</Label>
            <Input
              id="balloon_payment_due_date"
              type="date"
              value={formData.balloon_payment_due_date || ''}
              onChange={(e) => onInputChange('balloon_payment_due_date', e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BalloonPaymentSection;
